const CONSOLE_METHODS = [
  'log',
  'debug',
  'info',
  'warn',
  'error',
  'trace',
  'table',
  'group',
  'groupCollapsed',
  'groupEnd',
]

const noop = () => {}
const originalConsole = {}
const CONSOLE_DEBUG_SESSION_KEY = 'recolumn_console_debug_enabled'

CONSOLE_METHODS.forEach(method => {
  if (typeof console !== 'undefined' && typeof console[method] === 'function') {
    originalConsole[method] = console[method].bind(console)
  }
})

export function getConsolePolicy() {
  if (process.env.VUE_APP_CONSOLE_POLICY) return process.env.VUE_APP_CONSOLE_POLICY
  if (process.env.NODE_ENV === 'production') return 'super_admin'
  if (process.env.NODE_ENV === 'prosecution') return 'none'
  if (process.env.NODE_ENV === 'knu-hospital') return 'none'
  return 'all'
}

export function disableConsole() {
  CONSOLE_METHODS.forEach(method => {
    if (typeof console !== 'undefined') {
      console[method] = noop
    }
  })
}

export function enableConsole() {
  Object.keys(originalConsole).forEach(method => {
    console[method] = originalConsole[method]
  })
}

export function shouldDisableConsole(organizationPermission) {
  const policy = getConsolePolicy()
  if (policy === 'none') return true
  if (policy === 'super_admin') {
    return organizationPermission !== 'super_admin' || !isConsoleDebugEnabled()
  }
  return false
}

export function applyConsolePolicy(organizationPermission) {
  if (shouldDisableConsole(organizationPermission)) {
    disableConsole()
  } else {
    enableConsole()
  }
}

export function isConsoleDebugEnabled() {
  try {
    return window.sessionStorage.getItem(CONSOLE_DEBUG_SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export function setConsoleDebugEnabled(value) {
  try {
    if (value) {
      window.sessionStorage.setItem(CONSOLE_DEBUG_SESSION_KEY, '1')
    } else {
      window.sessionStorage.removeItem(CONSOLE_DEBUG_SESSION_KEY)
    }
  } catch {
    // sessionStorage may be unavailable in restricted browser modes.
  }
}

export function resetConsoleDebugSetting() {
  setConsoleDebugEnabled(false)
}
